import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { ITable } from 'src/app/api/modules/core/dynamic/components/ITable';

/**
 * Renders a server-configured data table (headers, rows, footers) with a
 * horizontally scrolling wrapper for narrow viewports.
 *
 * ### CSS Custom Properties
 *
 * Set these from any ancestor to restyle the component — they inherit through
 * view encapsulation, so no `::ng-deep` or `:host-context` is needed.
 *
 * | Property | Description | Default |
 * | --- | --- | --- |
 * | `--ds-table-scroller-max-width` | Max width of the scrolling wrapper | viewport minus two spacers |
 * | `--ds-table-scroller-margin` | Margin of the scrolling wrapper | `0` |
 */
@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent {
  /**
   * The configuration for this component.
   *
   * Nothing renders until a truthy config arrives.
   */
  readonly config = input<ITable | null>();
}
